import React, { useContext, useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { ILprEventSimpleProps } from '../../../services/Events/LprEventsService/types';
import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { getStreamByEndpointAsync } from '../../../services/Events';
import { LPR_EVENT_ENDPOINT } from '../../../services/Events/LprEventsService';
import { useGetAllLprEventByLicenseCountAsync } from '../../../services/Events/LprEventsService/hooks/useMutation';
import { IPaginationParams } from '../../../services/types';
import { AppContext } from '../../../context/AppContextProvider';
import ImageModalComponent from '../../../components/ImageModalComponent';
import ImageSimpleColumnComponent from '../../../components/ImageSimpleColumnComponent';
import PauseButtonComponent from '../../../components/PauseButtonComponent';
import { IEventPauseUpdateParams } from '../../../services/Events/types';
import {
  LPR_EVENTS_CACHE_KEY,
  useLprEventDataStreamCache,
} from '../../../services/Events/LprEventsService/hooks/useQueryClient';
import { t } from 'i18next';

const LprEventList = () => {
  const [events, setEvents] = useState<ILprEventSimpleProps[]>([]);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const { setIsShowLoadingComponent } = useContext(AppContext);
  const [eventCount, setEventCount] = useState<number>(0);
  const [isVisibleImageModal, setIsVisibleImageModal] =
    useState<boolean>(false);
  const [imageUrlToRender, setImageUrlToRender] = useState<string>('');
  const { mutateAsync: mutateGetAllLprEventByLicenseCount } =
    useGetAllLprEventByLicenseCountAsync();
  const { setCacheData, getCacheData, clearCacheData } =
    useLprEventDataStreamCache();
  const [pausedUpdateParams, setPausedUpdateParams] =
    useState<IEventPauseUpdateParams>({
      isPaused: false,
      cacheKey: LPR_EVENTS_CACHE_KEY,
      setCacheData: setCacheData,
      getCacheData: getCacheData,
      clearCacheData: clearCacheData,
    });

  const columns: IColumnProps[] = [
    {
      id: 'device.name',
      label: t('common.device'),
      width: '20%',
    },
    {
      id: 'plate',
      label: t('common.plate'),
      width: 200,
      align: 'center',
      render: (plate) => {
        if (!plate) return <>Não reconhecida</>;
        return <>{plate}</>;
      },
    },
    {
      id: 'speed',
      label: t('common.speed'),
      align: 'center',
      width: 200,
      render: (speed: string) => <>{speed} km/h</>,
    },
    {
      id: 'plateImage',
      label: t('common.plateImage'),
      width: '15%',
      align: 'center',
      render: (url) => {
        return (
          <ImageSimpleColumnComponent
            url={url}
            onClick={() => handleOpenImageModal(url)}
          />
        );
      },
    },
    {
      id: 'carImage',
      label: t('common.carImage'),
      width: '15%',
      align: 'center',
      render: (url) => {
        return (
          <ImageSimpleColumnComponent
            url={url}
            onClick={() => handleOpenImageModal(url)}
          />
        );
      },
    },
    {
      id: 'createdAt',
      label: t('common.date'),
      width: 205,
      render: (val) => <>{new Date(val).toLocaleString('pt-BR')}</>,
    },
  ];

  const handleOpenImageModal = (imageUrl: string) => {
    setIsVisibleImageModal(true);
    setImageUrlToRender(imageUrl);
  };

  const onResponseStream = () => {
    mutateGetAllLprEventByLicenseCount().then(setEventCount);
  };

  const refetchEvents = async () => {
    await getStreamByEndpointAsync(
      LPR_EVENT_ENDPOINT,
      setEvents,
      pagination,
      onResponseStream,
      setIsShowLoadingComponent,
      pausedUpdateParams,
    );
  };

  useEffect(() => {
    setIsShowLoadingComponent(true);
    refetchEvents();
  }, [pagination, pausedUpdateParams.isPaused]);

  return (
    <Box>
      <TableComponent
        columns={columns}
        totalCount={eventCount}
        rows={events}
        onChangePageOrRowsPerPage={setPagination}
        additionalTitleComponent={
          <PauseButtonComponent
            pausedUpdateParams={pausedUpdateParams}
            setPausedUpdateParams={setPausedUpdateParams}
          />
        }
        sortByName={'createdAt'}
        title={t('monitoring.eventsLPR')}
      />
      <ImageModalComponent
        isOpen={isVisibleImageModal}
        handleClose={() => setIsVisibleImageModal(false)}
        imageUrl={imageUrlToRender}
      />
    </Box>
  );
};

export default LprEventList;
